<template>
  <a-config-provider :locale="locale">
    <div class="dashboard-container">
      <div class="head">
        <div class="head-title">
          <div class="title">
            {{ $t('dashboard.title') }}
            <span style="margin-left: 8px"><a-icon type="exclamation-circle" theme="filled"
                style="color: rgb(53,109,255)" /></span>
            <span class="help-doc"><a
                href="https://doc.use.cool/send-cloud/use.html#%E4%BD%BF%E7%94%A8%E6%AD%A5%E9%AA%A4"
                target="_blank">{{$t('help.doc.title')}}</a></span>
          </div>
          <div class="ms">{{ $t('dashboard.ms') }}</div>
        </div>
        <div class="change-locale">
          <a-radio-group :default-value="enUS" @change="changeLocale" :value="currentLang">
            <a-radio-button key="en" :value="enUS">
              English
            </a-radio-button>
            <a-radio-button key="cn" :value="zhCN">
              中文
            </a-radio-button>
          </a-radio-group>
        </div>
      </div>
      <div class="app-container">
        <a-skeleton active :loading="loading">
          <a-row style="margin-top: 30px">
            <a-col :span="17" :push="7" style="padding-left: 10px; ">
              <a-card :bordered="false">
                <a-form :layout="formLayout" :form="keyForm" @submit="handleSubmit">
                  <a-form-item label="Name" :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol" class="item-title">
                    <a-input :placeholder="$t('dashboard.key.name.placeholder')"
                      v-decorator="['name', { rules: [{ required: true, message: $t('dashboard.key.name.msg')}] }]" />
                  </a-form-item>
                  <a-form-item label="Public Key" :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol" class="item-title">
                    <a-input
                      v-decorator="['publicKey', { rules: [{ required: true, message: $t('dashboard.key.publickey.msg') }] }]"
                      :placeholder="$t('dashboard.key.name.publickey.placeholder')" />
                  </a-form-item>
                  <a-form-item label="Secret Key" :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol" class="item-title">
                    <a-input
                      v-decorator="['secretKey', { rules: [{ required: true, message: $t('dashboard.key.secretKey.msg') }] }]"
                      :placeholder="$t('dashboard.key.name.secretkey.placeholder')" />
                  </a-form-item>
                  <a-button type="primary" html-type="submit">
                    {{$t('dashboard.key.btn.save')}}
                  </a-button>
                </a-form>
              </a-card>
            </a-col>
            <a-col :span="7" :pull="17" style="padding-right: 10px;">
              <div class="el-title">{{ $t('dashboard.key.title') }}</div>
              <div class="el-ms">
                <p>{{ $t('dashboard.key.title.ms') }}</p>
              </div>
            </a-col>
          </a-row>
        </a-skeleton>
        <a-skeleton active :loading="loading">
          <a-row style="margin-top: 30px">
            <a-col :span="17" :push="7" style="padding-left: 10px; ">
              <a-card :bordered="false">
                <a-form :layout="formLayout">
                  <a-form-item :label="$t('dashboard.sendcloud.api.version.card.title')" class="item-title">
                    <a-radio-group name="radioGroup" v-model="selectedVersion" :default-value="selectedVersion">
                      <a-radio value="v2">
                        V2
                      </a-radio>
                      <a-radio value="v3">
                        V3
                      </a-radio>
                    </a-radio-group>
                  </a-form-item>
                  <a-form-item :label="$t('dashboard.sendcloud.api.version.card.integration.title')" class="item-title" v-if="selectedVersion === 'v3'">
                    <a-select  style="width: 350px" v-model="appConfig.integrationId" >
                      <a-select-option :value="0" >
                        {{ $t('dashboard.sendcloud.api.version.card.integration.info')}}
                      </a-select-option>
                      <a-select-option :value="integration.id" v-for="(integration,index) in integrations" :key="index">
                        {{ integration.shop_name }}
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                  <a-button type="primary" @click="saveApiVersion()" :loading="btnLoading">
                    {{$t('dashboard.key.btn.save')}}
                  </a-button>
                </a-form>
              </a-card>
            </a-col>
            <a-col :span="7" :pull="17" style="padding-right: 10px;">
              <div class="el-title">{{$t('dashboard.sendcloud.api.version.title')}}</div>
              <div class="el-ms">
                <p>{{$t('dashboard.sendcloud.api.version.desc')}}</p>
              </div>
            </a-col>
          </a-row>
        </a-skeleton>
        <a-skeleton active :loading="loading">
          <a-row style="margin-top: 30px">
            <a-col :span="17" :push="7" style="padding-left: 10px; ">
              <a-card :bordered="false">
                <a-form :layout="formLayout">
                  <a-form-item :label="$t('dashboard.order.push.realtime')" class="item-title">
                    <a-switch @change="onChange" :checked="this.appConfig.realTimePush" />
                  </a-form-item>
                  <a-form-item :label="$t('dashboard.order.push.range')" class="item-title">
                    <a-range-picker @change="handleRangeChange" show-time />
                  </a-form-item>
                  <a-button type="primary" @click="rangePush()" :loading="btnLoading">
                    {{$t('dashboard.order.push.btn')}}
                  </a-button>
                </a-form>
              </a-card>
            </a-col>
            <a-col :span="7" :pull="17" style="padding-right: 10px;">
              <div class="el-title">{{$t('dashboard.order.push.title')}}</div>
              <div class="el-ms">
                <p>{{$t('dashboard.order.push.title.ms')}}</p>
              </div>
            </a-col>
          </a-row>
        </a-skeleton>
        <a-skeleton active :loading="loading">
          <a-row style="margin-top: 30px">
            <a-col :span="17" :push="7" style="padding-left: 10px; ">
              <a-card :bordered="false">
                <a-form :layout="formLayout">
                  <a-form-item label="WebHook Url" :label-col="formItemLayout.labelCol"
                    :wrapper-col="formItemLayout.wrapperCol" class="item-title">
                    <a-input :value="webHookUrl" />
                  </a-form-item>
                  <a-button type="primary" @click="copyToClipboard">
                    {{$t('dashboard.sendcloud.webhook.btn.text')}}
                  </a-button>
                </a-form>
              </a-card>
            </a-col>
            <a-col :span="7" :pull="17" style="padding-right: 10px;">
              <div class="el-title">{{$t('dashboard.sendcloud.webhook.title')}}</div>
              <div class="el-ms">
                <p>{{$t('dashboard.sendcloud.webhook.ms')}}</p>
              </div>
            </a-col>
          </a-row>
          <a-row style="margin-top: 30px">
            <a-col :span="17" :push="7" style="padding-left: 10px; ">
              <a-card :bordered="false">
                <div class="link-box">
                  <div class="link-item">
                    <div class="item-icon">
                      <a-icon type="bar-chart" style="font-size: 24px;color: #1890ff" />
                    </div>
                    <div class="link-item-rihgt">
                      <div class="item-title">{{$t('dashboard.order.push.log.title')}}</div>
                      <div class="item-ms">{{$t('dashboard.order.push.log.title.order.ms')}}</div>
                    </div>
                  </div>
                  <div class="link-btn">
                    <a-button type="primary" @click="goToSendLog">
                      {{$t('dashboard.order.push.log.title.order.btn')}}
                    </a-button>
                  </div>
                </div>
              </a-card>
            </a-col>
            <a-col :span="7" :pull="17" style="padding-right: 10px;">
              <div class="el-title">{{$t('dashboard.order.push.log.title')}}</div>
              <div class="el-ms">
                <p>{{$t('dashboard.order.push.log.title.ms')}}</p>
              </div>
            </a-col>
          </a-row>
          <a-row style="margin-top: 30px">
            <a-col :span="17" :push="7" style="padding-left: 10px;">
              <a-card :bordered="false">
                <div class="link-box">
                  <div class="link-item">
                    <div class="item-icon">
                      <a-icon type="shop" style="font-size: 24px;color: #1890ff" />
                    </div>
                    <div class="link-item-rihgt">
                      <div class="item-title">Sendcloud</div>
                      <div class="item-ms">{{$t('dashboard.sendcloud.title.ms')}}</div>
                    </div>
                  </div>
                  <div class="link-btn">
                    <a-button type="primary" @click="goToSencCloud">
                      {{$t('dashboard.order.push.log.title.order.btn')}}
                    </a-button>
                  </div>
                </div>
              </a-card>
            </a-col>
            <a-col :span="7" :pull="17" style="padding-right: 10px;">
              <div class="el-title">Sendcloud</div>
              <div class="el-ms">
                <p>{{$t('dashboard.sendcloud.title.ms')}}</p>
              </div>
            </a-col>
          </a-row>
        </a-skeleton>
      </div>
    </div>
  </a-config-provider>
</template>

<script>
import enUS from 'ant-design-vue/es/locale/en_US'
import zhCN from 'ant-design-vue/es/locale/zh_CN'
import moment from 'moment'
import 'moment/locale/zh-cn'
import { loadLanguageAsync } from '@/locales'
import storage from 'store'
import { login, getAppConfig, saveAppConfig, userInfo, userSave, queryOrder, createParcel, getIntegrations } from '@/api/api.js'
import pick from 'lodash.pick'
moment.locale('en')
const ACCESS_TOKEN = 'Access-Token'
const fields = ['name', 'publicKey', 'secretKey', 'realTimePush', 'id']
export default {
  name: 'index',
  data () {
    return {
      formLayout: 'vertical',
      enUS,
      zhCN,
      locale: enUS,
      url: null,
      params: {},
      currentLang: enUS,
      appConfig: {
        'name': '',
        'publicKey': '',
        'secretKey': '',
        'realTimePush': false
      },
      keyForm: this.$form.createForm(this, { name: 'keyConfig' }),
      loading: true,
      userInfo: null,
      dateRange: null,
      startDateISO: null,
      endDateISO: null,
      btnLoading: false,
      webHookUrl: `https://service.keepuse.com/sendcloud-api/api/webhook/parcel-status-changed`,
      webHookUrlOld: `https://shopline.use.cool:8086/api/webhook/parcel-status-changed`,
      selectedVersion: 'v2',
      integrations: []
    }
  },
  created () {
    this.initPage()
  },
  computed: {
    formItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 4 },
          wrapperCol: { span: 14 }
        }
        : {}
    },
    buttonItemLayout () {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          wrapperCol: { span: 14, offset: 4 }
        }
        : {}
    }
  },
  methods: {
    async initPage () {
      let code = this.getQueryString('code')
      this.permissions()
      this.webHookUrl = this.webHookUrl + '/' + this.params.handle
      this.loading = true
      await this.userLogin()
      console.log('ACCESS_TOKEN', storage.get(ACCESS_TOKEN))
      this.userInfo = await this.getUserInfo()
      console.log('userInfo', this.userInfo)
      if (code) {
        let data = {
          'isInstall': 1
        }
        console.log(data)
        this.userInfo = await this.submitUserSave(data)
      } else {
        if (!this.userInfo) {
          this.$router.push('/not-authorized')
          return
        }
        if (!this.userInfo.isInstall) {
          this.installApp()
          return
        }
        if (this.userInfo.isInstall === false) {
          this.installApp()
          return
        }
      }
      this.initLang()
      this.getConfig()
    },
    submitUserSave (e) {
      return new Promise((resolve, reject) => {
        userSave(e).then(res => {
          resolve(res.data)
        }).catch(err => {
          reject(err)
        })
      })
    },
    userLogin () {
      return new Promise((resolve, reject) => {
        login(this.params).then(res => {
          if (res.code === 200) {
            window.localStorage.setItem(ACCESS_TOKEN, res.data)
            resolve()
          }
        }).catch(err => {
          console.log(err)
          reject(err)
          this.$router.push('/not-authorized')
        })
      })
    },
    getUserInfo () {
      return new Promise((resolve, reject) => {
        userInfo().then(res => {
          if (res.code === 200) {
            resolve(res.data)
          }
        }).catch(err => {
          reject(err)
        })
      })
    },
    installApp () {
      let handle = this.getQueryString('handle')
      let appKey = this.getQueryString('appkey')
      let redirectUri = encodeURIComponent('https://sendcloud.keepuse.com')
      let url = `https://${handle}.myshopline.com/admin/oauth-web/#/oauth/authorize?appKey=${appKey}&responseType=code&scope=read_products,read_orders,write_orders,write_return&redirectUri=${redirectUri}`
      window.top.location = url
    },
    initLang () {
      let lang = storage.get('lang')
      if (lang) {
        if (lang === 'zh-CN') {
          loadLanguageAsync('zh-CN')
          moment.locale('zh-cn')
          this.locale = zhCN
          this.currentLang = zhCN
        }
        if (lang === 'en-US') {
          loadLanguageAsync('en-US')
          moment.locale('en')
          this.locale = enUS
          this.currentLang = enUS
        }
      }
    },
    permissions () {
      this.params.appkey = this.getQueryString('appkey')
      this.params.handle = this.getQueryString('handle')
      this.params.lang = this.getQueryString('lang')
      this.params.code = this.getQueryString('code')
      this.params.timestamp = this.getQueryString('timestamp')
      this.params.sign = this.getQueryString('sign')
      if (!this.params.appkey) {
        this.$router.push('/not-authorized')
        return
      }
      if (!this.params.handle) {
        this.$router.push('/not-authorized')
        return
      }
      if (!this.params.lang) {
        this.$router.push('/not-authorized')
        return
      }
      if (!this.params.timestamp) {
        this.$router.push('/not-authorized')
        return
      }
      if (!this.params.sign) {
        this.$router.push('/not-authorized')
      }
    },
    getConfig () {
      console.log('getConfig token is', window.localStorage.getItem(ACCESS_TOKEN))
      getAppConfig().then(res => {
        if (res.code === 200) {
          if (res.data) {
            this.appConfig = res.data
          }
          // 防止表单未注册
          fields.forEach(v => this.keyForm.getFieldDecorator(v))
          this.appConfig && this.keyForm.setFieldsValue(pick(this.appConfig, fields))
          this.selectedVersion = this.appConfig.apiVersion ? this.appConfig.apiVersion : 'v2'
          this.fetchIntegrations()
          this.loading = false
        }
      }).catch(err => {
        console.log(err)
      })
    },
    fetchIntegrations () {
      getIntegrations(this.appConfig.publicKey, this.appConfig.secretKey).then(res => {
        try {
          if (res.code === 200) {
            this.integrations = JSON.parse(res.data)
          }
        } catch (err) {
          console.error('Error parsing JSON:', err)
        }
      }).catch(err => {
        console.log(err)
      })
    },
    copyToClipboard () {
      var copyText = document.createElement('textarea')
      copyText.value = this.webHookUrl
      document.body.appendChild(copyText)
      copyText.select()
      document.execCommand('copy')
      document.body.removeChild(copyText)
      this.$message.info(this.$t('dashboard.sendcloud.webhook.btn.copy.info'))
    },
    goToSencCloud () {
      const strUrl = 'https://account.sendcloud.com/login/'
      let a = document.createElement('a')
      document.body.appendChild(a)
      a.style = 'display: none'
      a.target = '_blank'
      a.href = strUrl
      a.click()
      document.body.removeChild(a)
    },
    handleSubmit (e) {
      e.preventDefault()
      this.keyForm.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          let data = Object.assign(this.appConfig, values)
          this.postSave(data)
        }
      })
    },
    handleRangeChange (e) {
      console.log(e)
      this.dateRange = e
      // 使用 Moment.js 将日期范围格式化为 ISO8601 格式
      const startDate = moment(e[0]).format('YYYY-MM-DDTHH:mm:ssZ')
      const endDate = moment(e[1]).format('YYYY-MM-DDTHH:mm:ssZ')

      // 存储 ISO8601 格式的开始和结束日期
      this.startDateISO = startDate
      this.endDateISO = endDate
      console.log('this.startDateISO->', this.startDateISO)
      console.log('this.endDateISO->', this.endDateISO)
    },
    goToSendLog () {
      this.$router.push('/send-log')
    },
    async rangePush () {
      if (!this.dateRange) {
        this.$message.info(this.$t('select.range,date'))
        return
      }
      // 计算日期范围并检查是否大于 30 天
      const startDate = moment(this.dateRange[0])
      const endDate = moment(this.dateRange[1])
      const diffInDays = Math.abs(startDate.diff(endDate, 'days'))
      if (diffInDays > 30) {
        this.$message.info(this.$t('time.then.30.day'))
        return
      }
      this.btnLoading = true
      let orders = await this.requestQueryOrder()
      this.$message.info(orders.length + ' ' + this.$t('orders.found.res'))
      for (let i = 0; i < orders.length; i++) {
        this.requestCreateParcel(orders[i])
        if (i === orders.length - 1) {
          this.btnLoading = false
        }
      }
    },
    requestQueryOrder () {
      return new Promise((resolve, reject) => {
        let data = {
          'handle': this.params.handle,
          'createdAtMax': this.endDateISO,
          'createdAtMin': this.startDateISO
        }
        queryOrder(data).then(res => {
          if (res.code === 200) {
            resolve(res.data)
          }
        }).catch(err => {
          console.log(err)
          this.btnLoading = false
          reject(err)
        })
      })
    },
    requestCreateParcel (reqBody) {
      createParcel(reqBody).then(res => {
        if (res.code === 200) {
          this.$message.info(this.$t('btn.range.push.message'))
        }
      }).catch(err => {
        console.log(err)
      })
    },
    changeLocale (e) {
      const localeValue = e.target.value
      this.locale = localeValue
      if (localeValue.locale === 'zh-cn') {
        loadLanguageAsync('zh-CN')
        this.currentLang = zhCN
      }
      if (localeValue.locale === 'en') {
        loadLanguageAsync('en-US')
        this.currentLang = enUS
      }
      if (!localeValue) {
        moment.locale('en')
      } else {
        moment.locale('zh-cn')
      }
    },
    //  获取url参数
    getQueryString (name) {
      let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
      let r = window.location.search.substr(1).match(reg)
      if (r != null) {
        return decodeURIComponent(r[2])
      };
      return null
    },
    onChange (e) {
      console.log(e)
      this.appConfig.realTimePush = e
      this.postSave(this.appConfig)
    },
    postSave (data) {
      saveAppConfig(data).then(res => {
        console.log(res)
        if (res.code === 200) {
          console.log(this.$message)
          this.$message.info(this.$t('btn.save.message'))
          this.getConfig()
        }
      })
    },
    saveApiVersion () {
      this.appConfig.apiVersion = this.selectedVersion
      this.postSave(this.appConfig)
    }
  }
}
</script>

<style scoped>
  .dashboard-container {
    max-width: 1290px;
    margin: 0 auto;
    padding: 30px;
  }
  .head {
    height: 100px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .head-title {
    float: left;
  }
  .help-doc {
    color: #474f5e;
    font-size: 16px;
    font-weight: 500;
    margin-left: 8px;
  }
  .head .title {
    font-size: 22px;
    font-weight: 700;
    color: black;
    display: flex;
    align-items: center;
  }
  .head .ms {
    font-size: 14px;
    color: #333;
    margin-top: 20px
  }
  .app-container {
    width: 100%;
  }
  .el-title {
    font-size: 16px; font-weight: bold;
  }
  .el-ms {
    color: rgb(129, 135, 158); font-size: 14px;
  }
  p {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
  }
  .link-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .link-item {
    display: flex;
    align-items: center;
  }
  .link-item-rihgt {
    display: flex;
    flex-direction: column;
  }
  .item-icon {
    width: 22px;
    height: 27px;
    margin-right: 15px;
  }
  .item-title {
    font-size: 16px;
    font-weight: 700;
    padding-bottom: 10px
  }
</style>



// WEBPACK FOOTER //
// src/page/dashboard/index.vue